var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNpmLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1800pt",
    height: "1799.999925pt",
    viewBox: "0 0 1800 1799.999925",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 180 600.300781 L 1620 600.300781 L 1620 1199.410156 L 180 1199.410156 Z M 180 600.300781 "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(83.529663%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 180.730469 600.300781 L 1619.269531 600.300781 L 1619.269531 1109.542969 L 900 1109.542969 L 900 1199.410156 L 570.335938 1199.410156 L 570.335938 1109.542969 L 180.730469 1109.542969 Z M 180.730469 600.300781 "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 270.640625 1019.675781 L 420.488281 1019.675781 L 420.488281 780.035156 L 510.394531 780.035156 L 510.394531 1019.675781 L 570.335938 1019.675781 L 570.335938 690.167969 L 270.640625 690.167969 Z M 660.242188 690.167969 L 660.242188 1109.542969 L 810.089844 1109.542969 L 810.089844 1019.675781 L 959.9375 1019.675781 L 959.9375 690.167969 Z M 900 929.8125 L 810.089844 929.8125 L 810.089844 780.035156 L 900 780.035156 Z M 1049.847656 690.167969 L 1049.847656 1019.675781 L 1199.695312 1019.675781 L 1199.695312 780.035156 L 1289.605469 780.035156 L 1289.605469 1019.675781 L 1379.511719 1019.675781 L 1379.511719 780.035156 L 1469.421875 780.035156 L 1469.421875 1019.675781 L 1529.359375 1019.675781 L 1529.359375 690.167969 Z M 1049.847656 690.167969 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNpmLogo);
export default __webpack_public_path__ + "static/media/NpmLogo.f52365dccace1e4ad6b11c30e5a490e4.svg";
export { ForwardRef as ReactComponent };